var isArray = Array.isArray;

var isObject = function isObject(value) {
  return typeof value === 'object' && value !== null && !isArray(value);
};

var isContainer = function isContainer(value) {
  return isArray(value) || isObject(value);
};

function mapObject(object, fn) {
  var acc = {};

  for (var key in object) {
    acc[key] = fn(object[key], key, object);
  }

  return acc;
}

function forEachObject(object, fn) {
  for (var key in object) {
    fn(object[key], key, object);
  }
}

function map(container, fn) {
  return isArray(container) ? container.map(fn) : mapObject(container, fn);
}

function forEach(container, fn) {
  return isArray(container) ? container.forEach(fn) : forEachObject(container, fn);
}

module.exports = {
  isArray: isArray,
  isObject: isObject,
  isContainer: isContainer,
  map: map,
  forEach: forEach
};